<template>
	<div class="socialnetworks">
		<ul>
			<li>
				<a
					aria-label="Facebook"
					class="icon facebook big"
					rel="nofollow noopener noreferrer"
					href="#"
					target="_blank"
					@click.prevent="shareOnFacebook()"
				>
					<svg
						id="facebook"
						xmlns="http://www.w3.org/2000/svg"
						width="50.129"
						height="50.129"
						viewBox="0 0 50.129 50.129"
					>
						<path
							class="icon_network"
							d="M25.064,0A25.064,25.064,0,1,1,0,25.064,25.064,25.064,0,0,1,25.064,0Z"
							fill="#009cde"
						/>
						<path
							id="icon_facebook"
							d="M117.9,77.614h3.03V72.547h-3.562v.018c-4.316.173-5.2,2.919-5.279,5.8h-.009V80.9h-2.939v4.962h2.939v13.3h4.43v-13.3h3.629l.7-4.962h-4.328V79.37C116.506,78.4,117.079,77.614,117.9,77.614Z"
							transform="translate(-89.968 -60.836)"
							fill="#fff"
						/>
					</svg>
					<span class="srt">Facebook</span>
					<span class="srt">(opens a new window)</span>
				</a>
			</li>
			<li>
				<a
					aria-label="Twitter"
					class="icon twitter"
					rel="nofollow noopener noreferrer"
					href="#"
					target="_blank"
					@click.prevent="shareOnTwitter()"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="50.129"
						height="50.129"
						viewBox="0 0 50.129 50.129"
					>
						<path
							class="icon_network"
							d="M25.064,0A25.064,25.064,0,1,0,50.129,25.064,25.067,25.067,0,0,0,25.064,0ZM36.508,19.542q.017.37.016.743c0,7.6-5.786,16.368-16.369,16.369h0a16.284,16.284,0,0,1-8.818-2.584,11.7,11.7,0,0,0,1.372.08,11.543,11.543,0,0,0,7.145-2.463,5.759,5.759,0,0,1-5.375-4,5.734,5.734,0,0,0,2.6-.1,5.754,5.754,0,0,1-4.615-5.639c0-.026,0-.049,0-.073a5.713,5.713,0,0,0,2.606.719,5.758,5.758,0,0,1-1.781-7.68A16.333,16.333,0,0,0,25.148,20.93a5.756,5.756,0,0,1,9.8-5.246,11.539,11.539,0,0,0,3.653-1.4,5.775,5.775,0,0,1-2.53,3.182,11.474,11.474,0,0,0,3.3-.906A11.691,11.691,0,0,1,36.508,19.542Zm0,0"
							fill="#009cde"
						/>
					</svg>
					<span class="srt">Twitter</span>
					<span class="srt">(opens a new window)</span>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'SocialNetworks',
	props: ['url'],
	methods: {
		shareOnFacebook() {
			let url =
				'https://www.facebook.com/sharer/sharer.php?u=' +
				encodeURI(this.url)
			window.open(
				url,
				'fbShareWindow',
				'height=450, width=550, top=' +
					(window.innerHeight / 2 - 275) +
					', left=' +
					(window.innerWidth / 2 - 225) +
					', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
			)
		},
		shareOnTwitter() {
			let url =
				'https://twitter.com/share?url=' + encodeURIComponent(this.url)
			let text = ''
			window.open(
				url + '&text=' + text,
				'fbShareWindow',
				'height=450, width=550, top=' +
					(window.innerHeight / 2 - 275) +
					', left=' +
					(window.innerWidth / 2 - 225) +
					', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
			)
		},
	},
}
</script>

<style scoped lang="scss">
ul {
	@include flex-container;

	li {
		padding: 0 5px;
	}
}

a {
	&.facebook {
		margin: 0;
	}

	@include nomobile {
		&:hover,
		&:focus {
			.icon_network {
				fill: $yellowTheme;
			}
		}
	}
}

svg {
	width: 50px;
	height: 50px;
}

@include littleMaxDesktop {
	svg {
		width: 30px;
		height: 30px;
	}
}

@include mobile {
	svg {
		width: 50px;
		height: 50px;
	}
}
</style>
